'use client';

import Link from 'next/link';
import {useRouter, useSearchParams} from 'next/navigation';
import {ChevronRightSvg} from '@delorand/ui/src/svg/shared';
import {XMarkIcon} from '@heroicons/react/24/outline';

const HelpClient = () => {
  const searchParams = useSearchParams();
  const topicId = searchParams.get('topic');

  return (
    <div className="text-custom-white w-full px-2 pt-5 pb-7">
      {topicId && <Reader id={topicId} />}
      <h3 className="mx-auto text-center text-2xl font-semibold md:pt-5">
        HELP/FAQs
      </h3>

      {/* <div
        className='relative flex gap-2 mt-7 rounded-[10px] w-[95%] 
      overflow-hidden bg-white/10 items-center px-4 mx-auto'>
        <input
          className='py-2 w-full bg-transparent'
          placeholder='Type keywords like “return”'
        />
        <button>
          <SearchSvg fill='white' />
        </button>
      </div> */}

      <div className="mt-5 rounded-[10px] bg-black px-5">
        <h4 className="text-center text-lg font-medium">
          Questions we get the most
        </h4>
        <p className="text-[15px]">
          Here are the answers to the questions we get asked a lot.
        </p>
      </div>

      <div className="mt-3 grid w-full grid-cols-8 gap-3">
        <ArticleSection
          header="Shipment and delivery"
          topics={[
            {
              id: '1',
              title: 'Do you deliver nationwide ?',
            },
            {
              id: '2',
              title: 'How long does delivery take ?',
            },
            {
              id: '3',
              title: 'Do I pay for delivery fees ?',
            },
          ]}
        />

        <ArticleSection
          header="Payments"
          topics={[
            {
              id: '#',
              title: 'How can I pay for my purchases ?',
            },
            {
              id: '#',
              title: 'How secure are my payments ?',
            },
          ]}
        />
        <ArticleSection
          header="Orders & Returns"
          topics={[
            {
              id: '#',
              title: 'Can I track my orders ?',
            },
            {
              id: '#',
              title: 'Can I return an item ?',
            },
            {
              id: '#',
              title: 'Why was my order cancelled ?',
            },
            {
              id: '#',
              title: 'Will I get a refund after a return ?',
            },
            {
              id: '#',
              title: 'How long does a refund take to ?',
            },
          ]}
        />
        <ArticleSection
          header="Customer Servive"
          topics={[
            {
              id: '#',
              title: 'How to contact customer service ?',
            },
            {
              id: '#',
              title: 'What are our hours of operations ?',
            },
          ]}
        />
      </div>

      <div className="flex flex-col rounded-[10px] bg-black py-10">
        <h3 className="text-center text-lg font-medium">
          Still have questions ?
        </h3>
        <p className="text-center">
          Feel free to contact us for more information
        </p>
        <Link href={'/contact'} className="btn-white mx-auto mt-5 w-3/5 p-2">
          GET IN TOUCH
        </Link>
      </div>
    </div>
  );
};

const ArticleSection = ({
  header,
  topics,
}: {
  header: string;
  topics: {id: string; title: string}[];
}) => {
  const router = useRouter();
  return (
    <div className="col-span-8 md:col-span-4 lg:col-span-2">
      <div className="flex w-full items-center justify-center gap-4 border-b border-b-white/20 px-2 pt-2 pb-1">
        <h3 className="font-semibold">{header}</h3>
        {/* <div /> */}
      </div>
      <div className="w-full rounded-[10px] bg-black">
        {topics.map(topic => (
          <button
            key={topic.title}
            onClick={() => router.replace(`/help?topic=${topic.id}`)}
            className={`flex w-full gap-2 py-3 pr-3 pl-7`}
          >
            <p className="flex-1 text-[17px]">{topic.title}</p>
            <ChevronRightSvg />
          </button>
        ))}
      </div>
    </div>
  );
};

const Reader = ({id}: {id: string}) => {
  const router = useRouter();
  return (
    <div className="modal inset-0 p-4">
      <h3 className="text-center text-lg font-medium">Topic Title</h3>
      <button
        className="absolute top-3 right-3"
        onClick={() => router.replace('/help')}
      >
        <XMarkIcon width={30} />
      </button>
    </div>
  );
};

export default HelpClient;
